<template>
    <v-row
        v-if="actions.length"
        no-gutters
        style="z-index: 1; flex-grow: 0"
    >
        <v-col class="d-flex justify-end px-12 py-4">
            <v-btn
                v-for="(action, index) in actions"
                :key="index"
                :class="action.class"
                class="ml-2"
                :text="action.isTextStyle"
                :loading="action.loading && action.loading.value !== undefined ? action.loading.value : action.loading"
                :outlined="action.outlined"
                :disabled="action.disabled ? action.disabled.value : false"
                @click="action.click"
            >
                <v-icon
                    v-if="action.icon"
                    size="24"
                    left
                    color="primary"
                >
                    {{ action.icon }}
                </v-icon>
                <icon
                    v-else-if="action.newIcon"
                    size="24"
                    left
                    :icon="action.newIcon"
                    color="primary"
                />
                {{ $t( action.text) }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { ref, computed, onMounted, watch } from "@vue/composition-api";

export default {
    name: "AppStoreDialogActions",
    setup() {
        const { appStoreDialogGetters } = appStoreDialog()

        const actions = computed(() => appStoreDialogGetters.getFooterActions());

        return {
            actions
        }
    }
}
</script>